import { useEffect } from "react";
import { CalendarCheck } from "lucide-react";
import { Reveal } from "../components/common";
import { Seo, breadcrumbs } from "../components/Seo";

const CALENDLY_URL = "https://calendly.com/admin-dnafinance/30min?background_color=1a1a1a&text_color=d8ff00&primary_color=d8ff00";

export default function Booking() {
  useEffect(() => {
    const existing = document.querySelector('script[src="https://assets.calendly.com/assets/external/widget.js"]');
    if (existing) return;
    const script = document.createElement("script");
    script.src = "https://assets.calendly.com/assets/external/widget.js";
    script.async = true;
    document.body.appendChild(script);
  }, []);

  return (
    <div data-testid="booking-page" className="pt-32">
      <Seo title="Book a Consultation" path="/booking" description="Book a free, no-obligation consultation with a DNA Finance commercial finance adviser to discuss funding options for your business." jsonLd={breadcrumbs([{ name: "Home", path: "/" }, { name: "Book a Call", path: "/booking" }])} />
      <section className="container-x mx-auto max-w-[1000px] py-16">
        <Reveal className="text-center max-w-2xl mx-auto mb-12">
          <div className="inline-flex items-center gap-2 border border-lime/40 px-4 py-2 mb-6">
            <CalendarCheck className="w-4 h-4 text-lime" />
            <span className="text-xs uppercase tracking-[0.25em] text-lime">Book a Consultation</span>
          </div>
          <h1 className="text-4xl sm:text-5xl font-black tracking-tighter">Speak to a funding specialist</h1>
          <p className="text-grey text-lg mt-6">Pick a time that suits you. A dedicated adviser will call to discuss your requirements, no obligation.</p>
        </Reveal>

        <Reveal>
          <div className="border border-[#808080]/30 bg-[#1A1A1A] overflow-hidden">
            <div
              data-testid="calendly-widget"
              className="calendly-inline-widget"
              data-url={CALENDLY_URL}
              style={{ minWidth: "320px", height: "700px" }}
            />
          </div>
        </Reveal>

        <Reveal>
          <p className="text-center text-grey text-sm mt-6">Prefer to talk now? Call us on <a href="tel:+441792677652" className="text-lime hover:underline">01792 677652</a>.</p>
        </Reveal>
      </section>
    </div>
  );
}
